import "dayjs/locale/uk";

import { ConfigProvider, DatePicker, DatePickerProps } from "antd";
import uk from "antd/es/locale/uk_UA";
import dayjs, { Dayjs } from "dayjs";
import { FC } from "react";

dayjs.locale("uk");

type AppDatePickerProps = Omit<DatePickerProps<Dayjs>, "onChange"> & {
    onChange?: (date: Dayjs | null, dateString: string | null) => void;
};

export const AppDatePicker: FC<AppDatePickerProps> = ({
    style,
    onChange,
    ...rest
}) => {
    return (
        <ConfigProvider locale={uk}>
            <DatePicker
                style={{ fontFamily: "inherit", width: "100%", ...style }}
                onChange={onChange as DatePickerProps<Dayjs>["onChange"]}
                {...rest}
            />
        </ConfigProvider>
    );
};
